// ============================================================
// Cuchara Grande — Datos Editables del Evento
// Edita libremente este archivo para personalizar el contenido.
// ============================================================

export const event = {
  name: "Cuchara Grande",
  edition: "Edición León 450",
  subtitle: "Festival Gastronómico de León",
  tagline:
    "Una experiencia culinaria que celebra el talento local, la memoria gastronómica, la creatividad y los sabores de Guanajuato.",
  date: "Sábado, 18 de octubre de 2025",
  time: "18:30 — 23:30 hrs",
  venue: "Poliforum León — Salón Cantera",
  city: "León, Guanajuato",
  type: "Cena de gala y experiencia gastronómica",
  dressCode: "Cocktail elegante / Black tie opcional",
  contactEmail: "contacto@cucharagrande.mx",
  contactPhone: "+52 477 100 1000",
  expectedGuests: 320,
  status: "Confirmado",
  logoImage: "",
  logoAlt: "Cuchara Grande",
  aboutEyebrow: "Sobre el evento",
  aboutTitle: "Una experiencia que rinde homenaje al sabor del Bajío.",
  aboutText:
    "Cuchara Grande es un festival gastronómico que reúne a chefs, productores, aliados educativos e instituciones que han construido la identidad culinaria de León y del Bajío.\n\nCada edición es una celebración del talento local, de la memoria gastronómica y de la creatividad de quienes hacen cocina con respeto al producto, a la técnica y a la cultura.\n\nNo es solo una cena: es un punto de encuentro entre generaciones, escuelas, productores y comensales que comparten una misma mesa por una misma ciudad.",
  aboutCardEyebrow: "Edición especial",
  aboutCardTitle: "León 450",
  commemorativeText:
    "Esta edición celebra la historia, creatividad y riqueza culinaria de León como parte de los festejos por su 450 aniversario. Una mesa monumental que honra la memoria de la ciudad y proyecta su futuro gastronómico.",
  aboutImage: "",
  aboutImageAlt: "Imagen del evento",
  social: {
    instagram: "@cucharagrande.mx",
    instagramUrl: "https://www.instagram.com/cucharagrande.mx/",
    facebook: "/cucharagrande",
    facebookUrl: "https://www.facebook.com/cucharagrande",
    website: "cucharagrande.mx",
    websiteUrl: "https://cucharagrande.mx",
  },
  ticketButton: {
    enabled: true,
    label: "Comprar boletos",
    url: "/boletos",
  },
  location: {
    addressLine: "Blvd. Adolfo López Mateos 1102, León Centro",
    cityState: "37000 León, Guanajuato",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Poliforum+León+Guanajuato",
    directions:
      "Acceso por Blvd. Adolfo López Mateos. Desde Av. Olímpica, tomar la lateral oriente hasta el acceso principal del Poliforum.",
    parking:
      "Estacionamiento techado del Poliforum con capacidad para 600 vehículos. Tarifa preferencial para invitados con código QR.",
    access:
      "Acceso principal por la entrada norte. Acceso de proveedores y prensa por la entrada sur. Servicio de valet parking disponible.",
  },
};

export const program = [
  { time: "18:30", title: "Recepción de invitados", description: "Apertura de puertas, registro y cóctel de bienvenida." },
  { time: "19:00", title: "Bienvenida institucional", description: "Saludo del comité organizador y aliados culturales." },
  { time: "19:30", title: "Presentación oficial — Edición León 450", description: "Mensaje conmemorativo por los 450 años de la ciudad." },
  { time: "20:00", title: "Experiencia gastronómica", description: "Cinco tiempos diseñados por los chefs invitados con maridaje." },
  { time: "21:30", title: "Intervenciones especiales", description: "Mensajes de chefs, productores y aliados educativos." },
  { time: "22:15", title: "Reconocimientos", description: "Entrega de distinciones a chefs, productores locales y aliados." },
  { time: "22:45", title: "Cierre y foto oficial", description: "Foto oficial con todo el equipo, chefs y patrocinadores." },
];

export const chefs = [
  {
    name: "Chef Oswal Medina",
    role: "Líder Gastronómico — Cocina contemporánea mexicana",
    bio: "Reconocido por reinterpretar la cocina del Bajío con técnica moderna y profundo respeto por el producto local.",
    participation: "Dirige el menú colaborativo y el tiempo principal.",
    photo: "https://images.unsplash.com/photo-1611657365907-1ca5d9799f59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxjaGVmJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgyNTAxODEyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Chef Lucy Noriega",
    role: "Repostería y cocina dulce de autor",
    bio: "Su trabajo explora ingredientes endémicos del centro de México con un lenguaje pastelero contemporáneo.",
    participation: "Diseña el cierre dulce y la mesa de postres.",
    photo: "https://images.pexels.com/photos/24252237/pexels-photo-24252237.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Chef Ale Maldonado",
    role: "Cocina de producto y fermentación",
    bio: "Apuesta por la cocina de temporada, fermentos artesanales y diálogo con productores del Bajío.",
    participation: "Entrada fría y propuestas de fermentos.",
    photo: "https://images.unsplash.com/photo-1512485800893-b08ec1ea59b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxjaGVmJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgyNTAxODEyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Chef Jaime Lucas",
    role: "Cocina al fuego y técnicas tradicionales",
    bio: "Defensor de la cocina al carbón, los rescoldos y las técnicas ancestrales mexicanas.",
    participation: "Tiempo principal a las brasas, cocina en vivo.",
    photo: "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    name: "Chef Mauricio Ortiz",
    role: "Coctelería de autor y maridaje",
    bio: "Arquitecto líquido especializado en destilados mexicanos y coctelería conceptual.",
    participation: "Coctelería de bienvenida y maridaje especial.",
    photo: "https://images.unsplash.com/photo-1551024709-8f23befc6f87?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    name: "Luis de Quinto",
    role: "Curaduría sensorial y ambiente",
    bio: "Curador del lenguaje estético del evento: mesa, ambientación y narrativa visual.",
    participation: "Diseño de mesa y narrativa de espacio.",
    photo: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    name: "Aliados Educativos",
    role: "Instituciones gastronómicas de León",
    bio: "Estudiantes y docentes de escuelas gastronómicas locales acompañan la operación como aprendizaje vivo.",
    participation: "Brigada de apoyo, servicio y observación pedagógica.",
    photo: "https://images.unsplash.com/photo-1581349485608-9469926a8e5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export const menu = [
  {
    course: "Bienvenida",
    name: "Aguachile verde de jícama y hierbabuena",
    description: "Apertura fresca con jícama del Bajío, chile serrano y aceite de hierbabuena.",
    ingredients: ["Jícama", "Hierbabuena", "Chile serrano", "Limón persa"],
    chef: "Chef Ale Maldonado",
    pairing: "Mezcal joven cítrico",
    image: "https://images.unsplash.com/photo-1514944617518-12c7891ec602?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxmaW5lJTIwZGluaW5nJTIwbWV4aWNhbiUyMGN1aXNpbmUlMjBwbGF0aW5nfGVufDB8fHx8MTc4MjUwMTgwMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    course: "Entrada",
    name: "Tetela de maíz azul rellena de hongos del cerro",
    description: "Masa nixtamalizada de maíz azul con hongos silvestres del Bajío y salsa de chile pasilla.",
    ingredients: ["Maíz azul", "Hongos silvestres", "Chile pasilla", "Epazote"],
    chef: "Chef Oswal Medina",
    pairing: "Vino blanco mexicano, notas minerales",
    image: "https://images.unsplash.com/photo-1676664778856-b48a7d87d831?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxmaW5lJTIwZGluaW5nJTIwbWV4aWNhbiUyMGN1aXNpbmUlMjBwbGF0aW5nfGVufDB8fHx8MTc4MjUwMTgwMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    course: "Plato fuerte",
    name: "Cordero al rescoldo con mole verde de pepita",
    description: "Cordero confitado bajo brasas, mole verde con pepita tostada y verdolagas tiernas.",
    ingredients: ["Cordero", "Pepita de calabaza", "Verdolagas", "Tomate verde"],
    chef: "Chef Jaime Lucas",
    pairing: "Tinto del altiplano, crianza corta",
    image: "https://images.unsplash.com/photo-1761314015301-802ba0c7dbb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxmaW5lJTIwZGluaW5nJTIwbWV4aWNhbiUyMGN1aXNpbmUlMjBwbGF0aW5nfGVufDB8fHx8MTc4MjUwMTgwMHww&ixlib=rb-4.1.0&q=85",
  },
  {
    course: "Quesos",
    name: "Tabla de quesos artesanales del Bajío",
    description: "Selección de quesos locales acompañados de mermelada de tuna y nuez caramelizada.",
    ingredients: ["Queso de cabra", "Queso oreado", "Tuna", "Nuez"],
    chef: "Aliados productores locales",
    pairing: "Cava artesanal mexicana",
    image: "https://images.unsplash.com/photo-1452195100486-9cc805987862?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    course: "Postre",
    name: "Tres leches de cajeta y vainilla de Papantla",
    description: "Pan esponja embebido en tres leches con cajeta de Celaya y aire de vainilla de Papantla.",
    ingredients: ["Cajeta", "Vainilla", "Leche entera", "Crema"],
    chef: "Chef Lucy Noriega",
    pairing: "Café de altura de Guanajuato",
    image: "https://images.unsplash.com/photo-1551024601-bec78aea704b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export const gallery = [
  "https://images.unsplash.com/photo-1528605248644-14dd04022da1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxvdXRkb29yJTIwZm9vZCUyMGZlc3RpdmFsJTIwZWxlZ2FudCUyMGRpbmluZyUyMGF0bW9zcGhlcmV8ZW58MHx8fHwxNzgyNTAxODAwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1635702786344-f09eff66e7c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxvdXRkb29yJTIwZm9vZCUyMGZlc3RpdmFsJTIwZWxlZ2FudCUyMGRpbmluZyUyMGF0bW9zcGhlcmV8ZW58MHx8fHwxNzgyNTAxODAwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1676664778856-b48a7d87d831?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxmaW5lJTIwZGluaW5nJTIwbWV4aWNhbiUyMGN1aXNpbmUlMjBwbGF0aW5nfGVufDB8fHx8MTc4MjUwMTgwMHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1514944617518-12c7891ec602?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxmaW5lJTIwZGluaW5nJTIwbWV4aWNhbiUyMGN1aXNpbmUlMjBwbGF0aW5nfGVufDB8fHx8MTc4MjUwMTgwMHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1611657365907-1ca5d9799f59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxjaGVmJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgyNTAxODEyfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1551024709-8f23befc6f87?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1552566626-52f8b828add9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
];

export const faqs = [
  { q: "¿Dónde se llevará a cabo el evento?", a: "En el Poliforum León — Salón Cantera, ubicado en Blvd. Adolfo López Mateos 1102, León Centro." },
  { q: "¿A qué hora comienza?", a: "La recepción inicia a las 18:30 hrs. La experiencia gastronómica formal arranca a las 20:00 hrs." },
  { q: "¿Qué incluye mi acceso?", a: "Cóctel de bienvenida, cena de cinco tiempos, maridaje, presentaciones especiales, kit conmemorativo de la Edición León 450 y servicio de fotografía." },
  { q: "¿Puedo transferir mi acceso?", a: "Sí, con autorización previa del comité organizador antes del 10 de octubre. Escríbenos a contacto@cucharagrande.mx." },
  { q: "¿Hay estacionamiento?", a: "Sí, el Poliforum cuenta con estacionamiento techado y tarifa preferencial con código QR para invitados." },
  { q: "¿Con quién puedo contactar para dudas?", a: "Con el comité organizador al teléfono +52 477 100 1000 o por correo a contacto@cucharagrande.mx." },
];
